module.exports = __webpack_public_path__ + "assets/img/bubble_top.svg";